var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 2.33203H10.4997C10.8091 2.33203 11.1058 2.45495 11.3246 2.67374C11.5434 2.89253 11.6663 3.18928 11.6663 3.4987V11.6654C11.6663 11.9748 11.5434 12.2715 11.3246 12.4903C11.1058 12.7091 10.8091 12.832 10.4997 12.832H3.49967C3.19026 12.832 2.89351 12.7091 2.67472 12.4903C2.45592 12.2715 2.33301 11.9748 2.33301 11.6654V3.4987C2.33301 3.18928 2.45592 2.89253 2.67472 2.67374C2.89351 2.45495 3.19026 2.33203 3.49967 2.33203H4.66634",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75033 1.16797H5.25033C4.92816 1.16797 4.66699 1.42914 4.66699 1.7513V2.91797C4.66699 3.24013 4.92816 3.5013 5.25033 3.5013H8.75033C9.07249 3.5013 9.33366 3.24013 9.33366 2.91797V1.7513C9.33366 1.42914 9.07249 1.16797 8.75033 1.16797Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/catalog.636ad012.svg";
export { ForwardRef as ReactComponent };